module.exports = require('./helpers/bundle-url').getBundleURL('8kqgc') + "face-icon.f1f08179.png";